import { Injectable, Type } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalWrapperComponent } from '../components/modal-wrapper/modal-wrapper.component';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  constructor(private dialog: MatDialog) { }

  openModal<C, D = unknown, R = unknown>(component: Type<C>, data?: D, config?: Omit<MatDialogConfig, 'data'>) {
    return this.dialog.open<ModalWrapperComponent, any, R>(
      ModalWrapperComponent,
      {
        panelClass: config?.panelClass ?? 'a',
        backdropClass: 'modal-backdrop-blur',
        hasBackdrop: true,
        autoFocus: false,
        ...config,
        data: {
          component,
          data
        },
      }
    );
  }
}
